import {
  buildFacebookPdpAttributes,
  commonFacebookEventsUtil,
} from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { ProductDetail } from '../../domain/models/ProductDetail';
import type { PdpEffectiveProductVm } from '../viewModels/pdp.vm';

export function facebookCustomizeProduct(
  product: ProductDetail,
  vm: PdpEffectiveProductVm,
  selectedSizeDisplay?: string,
): void {
  commonFacebookEventsUtil(
    'CustomizeProduct',
    buildFacebookPdpAttributes(product, vm, selectedSizeDisplay),
  );
}
